module.exports = __webpack_public_path__ + "img/moren-guanggao.d9dae73e.jpg";